import WidgetModule from "@eisinc/Overrides/Widgets/Basic/Image";

export * from "@eisinc/Overrides/Widgets/Basic/Image";

export default WidgetModule;
